import { render, staticRenderFns } from "./ChosenPreferences.vue?vue&type=template&id=22f544de&scoped=true"
import script from "./ChosenPreferences.vue?vue&type=script&lang=js"
export * from "./ChosenPreferences.vue?vue&type=script&lang=js"
import style0 from "./ChosenPreferences.vue?vue&type=style&index=0&id=22f544de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f544de",
  null
  
)

export default component.exports